import { apiRequest } from '@/core';
import { type CreateMatchPayload } from '@/slices/matches/types';

export const createMatchRequest = async (matchData: CreateMatchPayload) =>
  apiRequest<void>({
    endpoint: 'api/matches',
    body: matchData,
  });
